/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlanTemplates/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TxPlanTemplates from './TxPlanTemplates/index'
let TxPlanTemplate = React.lazy(() => import('./TxPlanTemplate/index'))



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlanTemplates({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'TxPlanTemplates'
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'TxPlanTemplates'}>
<TxPlanTemplates
{...childProps}
  viewPath={`${viewPath}/TxPlanTemplates`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TxPlanTemplate'}>
<TxPlanTemplate
{...childProps}
  viewPath={`${viewPath}/TxPlanTemplate`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
{children}
</React.Fragment>)
}